import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';

export const ArticleText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& h3': {
    color: colors.caramel,
    fontFamily: fonts.title,
    fontSize: 16,
    lineHeight: '19px',
    fontWeight: 'bold',
  },
});

export const Paragraph = styled('div')({
  fontSize: 16,
  lineHeight: '22px',
  color: colors.darkBrown,
  '& ul': {
    paddingLeft: 20,
  },
  '& p a, & ul a, & ol a': {
    color: colors.caramel,
  },
});
